import ItemView, {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import { updateItem } from 'store/providers/providerSlice';
import image from '../../../../assets/images/form.png';
import { IUsers } from '../../../../store/store';
import i18n from '../../../../i18n';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';

interface IComponentProps extends IComponentBaseProps {
  users: IUsers;
}

interface IComponentState extends IComponentBaseState {}

class ChartView extends ItemView<IComponentProps, IComponentState> {
  private chartImage: any;
  constructor(props: IComponentProps) {
    super(props);
    this.chartImage = image;
  }
  deleteItemTitle() {
    return '';
  }

  deleteItemMessage() {
    return '';
  }

  onOpenFunction(item: IProviderItemViewWithData) {
    return () => {
      this.props.onOpenItem(item, 'view');
    };
  }

  getThumbnail() {
    if (this.props.item.data.thumbnailUrl) {
      return this.props.item.data.thumbnailUrl;
    }
    return this.chartImage;
  }

  handelConfirmCreatingNewItem() {
    throw new Error(
      `please provide handelConfirmCreatingNewItem() for ${this.constructor.name}`
    );
  }

  newItemPlaceHolder() {
    throw new Error(
      `please provide newItemPlaceHolder() for ${this.constructor.name}`
    );
  }

  newItemTitle() {
    return '';
  }

  getMenuActions() {
    return [
      {
        message: i18n.t('rename', { ns: 'documentManager' }),
        callBack: () => {
          this.setState({ rename: true });
        },
        order: 1,
      },
      {
        message: i18n.t('changeThumbnail', { ns: 'documentManager' }),
        callBack: () => {
          this.handleChangeThumbnail();
        },
        order: 2,
      },
      {
        message: i18n.t('changeLimitation', { ns: 'documentManager' }),
        callBack: () => {
          this.handleChangeLimitation();
        },
        order: 3,
      },
      {
        type: 'divider',
        order: 3.5,
      },
      {
        message: i18n.t('move', { ns: 'documentManager' }),
        callBack: () => {
          this.props.onMoveItem();
        },
        order: 4,
      },
    ];
  }

  updateItemFunction() {
    return updateItem;
  }
}
export default ChartView;
